import React from 'react';
export function IssuerHeader() {
  return <div className="min-w-0 text-left" data-id="element-1367" data-mp="2exccgahlhrng">
      <img src="https://cdn.magicpatterns.com/uploads/3HmLapdTMRvTJbmSkdh1g8/Bmedhospital.png" alt="BMED Medical Centre" className="mb-2 h-14 w-14 object-contain" data-id="element-1368" data-mp="b6x7lr64b60t" />
      <p className="billing-issuer-name font-bold uppercase tracking-wide text-pink-600" data-id="element-1369" data-mp="1h576gbc7iof">
        BMED MEDICAL CENTRE
      </p>
      <p className="mt-0.5 italic text-slate-600" data-id="element-1370" data-mp="3so7yr8v37qz6">Caring Healing Leading</p>
      <address className="billing-issuer-contact mt-3 space-y-0.5 not-italic text-slate-700" data-id="element-1371" data-mp="3oltjeyqmn9cn">
        <p data-id="element-1372" data-mp="3jm8fe9wloat2">Plot No. 1884/10, Along Avic Road, Lilayi Estate</p>
        <p data-id="element-1373" data-mp="3jmqj1rlldrb0">Kafue, Lusaka - Zambia</p>
        <p data-id="element-1374" data-mp="3enngcdt33x67">Contact: +260975202011</p>
        <p data-id="element-1375" data-mp="3eop2bdbn242p">Email: bmedhospital@gmail.com</p>
        <p data-id="element-1376" data-mp="3epqc7egx4kiu">TPIN:2000869447</p>
      </address>
    </div>;
}